/**
* Simple utility to handle routing and downloading message chunks. Message chunks should be
* any 'entry' message point. You can identify an 'entry' message as one the merchant can
* use by decorating the script tag attribute 'data-msg'.
**/

var cache = require('../models/cache'),
  CONST_ERROR = require("../constants/errors"),
  log = require("../libraries/logger").getLoggerInstance('Base.MessageRouter'),
  htmlUtility = require('../utilities/htmlUtility'),
  endpointMonitor = require('../libraries/endpointMonitor'),
  GeneralError = require('../models/errors/generalError'),
  RSVP = require('rsvp');

var methods = {
  route: function () {
    log.debug('Searching for correct Message route...');

    var promise = new RSVP.Promise(function (resolve, reject) {

      switch (cache.message) {
        case 'collect':
          require.ensure([], function (require) {
            resolve(require('./collect').process());

            endpointMonitor.captureTiming(htmlUtility.getCurrentScript());
          }, 'collect');
          break;
        case 'init':
          require.ensure([], function (require) {
            resolve(require('./init').process());

            endpointMonitor.captureTiming(htmlUtility.getCurrentScript());
          }, 'init');
          break;
        case 'complete':
          require.ensure([], function (require) {
            resolve(require('./complete').process());

            endpointMonitor.captureTiming(htmlUtility.getCurrentScript());
          }, 'complete');
          break;
        case 'confirm':
          require.ensure([], function (require) {
            resolve(require('./confirm').process());

            endpointMonitor.captureTiming(htmlUtility.getCurrentScript());
          }, 'confirm');
          break;
        default:
          reject(new GeneralError(CONST_ERROR.CONFIGURATION.NUMBER, 'Unknown message type'));
      }
    });

    return promise;
  }
};

module.exports = methods;



//////////////////
// WEBPACK FOOTER
// ./messages/messageRouter.js
// module id = 114
// module chunks = 5